<template>
    <div class="tab-publication">
        <div class="blockcont">
            <div class="smalltitle">Publications</div>
            <ul class="itemlist">
                <li>
                    <div class="row">
                        <div class="col-xs-6"><strong style="cursor: pointer">Title</strong></div>
                        <div class="col-xs-2"><strong style="cursor: pointer">Journal</strong></div>
                        <div class="col-xs-2"><strong style="cursor: pointer">Year, volume, page</strong></div>
                        <div class="col-xs-2" style="text-align: center"><strong>Action</strong></div>
                    </div>
                </li>
                <li v-for="item in publicationData">
                    <div class="row">
                        <div class="col-xs-6">{{item.title}}</div>
                        <div class="col-xs-2">{{item.journal}}</div>
                        <div class="col-xs-2">{{item.yearVolumnPage}}</div>
                        <div class="col-xs-2 itemaction" style="text-align: center;">

                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="blockcont">
            <div class="smalltitle">Copy & Paste Your Publication</div>
            <form>
                <div class="profield" style="width: 100%;">
                    <textarea v-model="textPublication" rows="7" style="width: 100%"
                              :disabled="disabledForm"></textarea>
                </div>

            </form>

        </div>
        <div class="blockcont">
            <div class="smalltitle">Add link to List of Your Publications on PubMed</div>
            This is displayed as <em><strong>“List of recent articles”</strong></em> under Publications section
            on your profile. Leave it blank if you don’t have one.
            <form>
                <div class="prolabel">Link (Optional)</div>
                <div class="profield"><input type="text" v-model="publicationLink" :disabled="disabledForm"></div>

            </form>
        </div>

    </div>
</template>

<script>
import CommonMixin from './../../../../mixins/general/CommonMixin.vue'
import config from '../../../../config'
import httpClient from '../../../../client'

export default {
  name: 'TabPublication',
  components: {},
  props: {
    userInfo: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      publicationData: [],
      publicationLink: '',
      textPublication: ''
    }
  },
  computed: {
    disabledForm () {
      return true
    }
  },
  watch: {},
  updated () {
  },
  mounted () {
    this.getPositionAp()
  },
  beforeDestroy () {
  },
  methods: {
    async getPositionAp () {
      try {
        let response = await httpClient.get('/users/publication/' + this.userInfo.id)
        if (response.data.s === 200) {
          this.publicationData = response.data.data.publications
          this.publicationLink = response.data.data.link
          this.textPublication = response.data.data.text
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError(e.message)
      }
    }
  }
}
</script>
<style scoped="">

</style>
